import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b56b728a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b56b728a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56b728a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56b728a')) {
      api.createRecord('b56b728a', component.options)
    } else {
      api.reload('b56b728a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b56b728a&scoped=true", function () {
      api.rerender('b56b728a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/turnover/index.vue"
export default component.exports